"use client"
import { useTranslations } from 'next-intl';
import style from './pagination.module.scss';
import Link from 'next/link';
import Chevron from '../svg/Chevron';
import PaginationDto from '@/projectRoot/api-client/interfaces/request/Pagination.dto';

interface Props {
    classes?: string[];
    handleOnClick?: (page: number) => void;
    pagination: PaginationDto;
}

export const SimplePagination = ({ classes = [], handleOnClick, pagination }: Props) => {
    const t = useTranslations();
    const currentPage: number = pagination?.page ?? 1;
    const totalPages: number = pagination?.total_pages ?? 1;

    const applyViewHref = (page: number): string => {
        let returnalbe = '/';
        if (typeof window != 'undefined') {
            const queryParams = new URLSearchParams(window.location.search)
            queryParams.set('page', page.toString());
            returnalbe = `${window.location.origin}${window.location.pathname}?${queryParams.toString()}`;
        }
        return returnalbe;
    }

    const customChangePage = (event: any, page: number): void => {
        if(typeof handleOnClick != 'undefined') {
            event.preventDefault();
            handleOnClick(page);
        }
    }

    const onClickScrollToTop = () => {
        if(typeof window !== 'undefined'){
            window.scrollTo(0, 0);
        }
    }


    return (
        <div className={`${style.paginationWrapper} ${classes.join(' ')}`}>
            <span className={style.backToTop} onClick={onClickScrollToTop}>
                {t('back_to_top')}
            </span>
            {
                pagination.total_rows > pagination.rows_per_page
                ?
                <nav className={`${style.pagination} ${style.simplePagination}`}>
                    {
                        currentPage !== 1 ?
                            <Link className={`${style.pageLink} ${style.prevPage}`} href={applyViewHref(currentPage - 1)}>
                                <span className={`${style.prevPage}`}  onClick={(e) => customChangePage(e, currentPage - 1)}>
                                    <Chevron />
                                </span>
                                {t('previous')}
                            </Link>
                            : <></>
                    }
                    {
                        <span className={`${style.pageLink} ${style.current}`} style={{marginInline: 'auto'}}>
                            {currentPage} {t('of')} {totalPages}
                        </span>
                    }
                    {
                        currentPage !== totalPages ?
                            <Link className={`${style.pageLink} ${style.nextPage}`} href={applyViewHref(currentPage + 1)}>
                                {t('next')}
                                <span onClick={(e) => customChangePage(e, currentPage + 1)}>
                                    <Chevron />
                                </span>
                            </Link>
                            : <></>
                    }
                </nav>
                : <></>
            }
        </div>
    )
}

export default SimplePagination;